import {
  makeDataState,
  makePaginationState,
  concatUnique,
  STATUSES,
} from 'app/utils/redux';

import * as t from './types';

const initialState = {
  info: makeDataState(),
  withdrawals: makePaginationState(),
};

export default (state = initialState, action) => {
  switch (action.type) {
    case `${t.FETCH_WITHDRAWL_INFO}_PENDING`:
      return {
        ...state,
        info: {
          ...state.info,
          status: STATUSES.PENDING,
        },
      };
    case `${t.FETCH_WITHDRAWL_INFO}_SUCCESS`:
      return {
        ...state,
        info: {
          status: STATUSES.SUCCESS,
          isLoaded: true,
          data: action.payload.result,
        },
      };
    case `${t.FETCH_WITHDRAWL_INFO}_ERROR`:
      return {
        ...state,
        info: {
          ...state.info,
          status: STATUSES.ERROR,
        },
      };

    case `${t.FETCH_EXCHANGE_LIST}_PENDING`:
      return {
        ...state,
        withdrawals: {
          ...state.withdrawals,
          status: STATUSES.PENDING,
        },
      };
    case `${t.FETCH_EXCHANGE_LIST}_SUCCESS`:
      return {
        ...state,
        withdrawals: {
          isLoaded: true,
          status: STATUSES.SUCCESS,
          pagination: {
            ...action.payload.result,
            items: concatUnique(
              state.withdrawals.pagination.items,
              action.payload.result.items
            ),
          },
        },
      };
    case `${t.FETCH_EXCHANGE_LIST}_ERROR`:
      return {
        ...state,
        withdrawals: {
          ...state.withdrawals,
          status: STATUSES.ERROR,
        },
      };

    case `${t.EXCHANGE}_SUCCESS`:
      return {
        ...state,
        withdrawals: {
          ...state.withdrawals,
          pagination: {
            ...state.withdrawals.pagination,
            items: [action.payload.result].concat(
              state.withdrawals.pagination.items
            ),
          },
        },
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/app/redux/front/withdrawal/reducer.js